import React, { ReactNode, useState } from 'react'

import { OptionProps } from 'antd/lib/select'
import { useField, useFormikContext } from 'formik'

import Label from '../components/Label'
import Select from '../components/Select'
import FieldProps from './FieldProps'
import Error from './FormItemError'

interface SelectProps extends FieldProps {
  defaultValue?: string[]
  mode?: 'default' | 'multiple'
  size?: 'default' | 'large' | 'small'
  value?: string[] | number[]
  customOption: ReactNode
  disabled?: boolean
  customOptionClassname?: string
  dropdownMatchSelectWidth?: boolean
  customOptionPlaceholder?: ReactNode
  filterOption?: boolean | ((inputValue: string, option: React.ReactElement<OptionProps>) => boolean)
  onKeyDown?: (e: React.KeyboardEvent<HTMLElement>) => void
}

const FormikSelectField: React.FC<SelectProps | any> = (props) => {
  const [field, meta] = useField(props)
  const context = useFormikContext()
  const showError = meta.touched && meta.error
  const error = showError ? <Error>{meta.error}</Error> : null
  const [open, setOpen] = useState<boolean>(false)

  const onChange = (value: any, key: any) => {
    context.setFieldValue(props.name, value)
    props.onChange && props.onChange(key.key)
  }

  const onBlur = (value: any) => {}

  let lock: any = null
  const lockClose = (e: any) => {
    clearTimeout(lock)
    lock = setTimeout(() => {
      lock = null
    }, 100)
  }

  const onDropdownVisibleChange = (open: any) => {
    if (lock) return
    setOpen(open)
  }

  return (
    <>
      <div>
        {props.label && (
          <Label htmlFor={props.id || props.name} className="no-select hand-on-hover">
            {props.label}
          </Label>
        )}
        <Select
          {...props}
          className={`input__no-autofill-color ${props.className}`}
          onChange={onChange}
          onBlur={onBlur}
          open={open}
          onKeyDown={props.onKeyDown}
          onDropdownVisibleChange={(e) => onDropdownVisibleChange(e)}
          dropdownRender={(menu) => (
            <div>
              {menu}
              {
                <div onMouseDown={(e) => lockClose(e)} onMouseUp={(e) => lockClose(e)}>
                  <div className="flex" style={{ alignItems: 'center' }}>
                    <div>
                      <p className="ml-12">{props.customOptionPlaceholder}</p>
                    </div>

                    <div className={`${props.customOptionClassname} mr-8 ml-8 mt-16`}>{props.customOption} </div>
                  </div>
                </div>
              }
            </div>
          )}
        >
          {props.children}
        </Select>
      </div>
      {error}
    </>
  )
}
export { FormikSelectField as SelectWithChildren }
export default FormikSelectField
